import gql from 'graphql-tag';

const updateUserQuery = gql`
  mutation UpdateUser($userId: String!, $input: UpdateUserInput!) {
    updateUser(userId: $userId, input: $input) {
      userId
    }
  }
`;

export default (() => ({
  mutation: updateUserQuery,
  module: 'users',
  buildVariables: ({ userId, input }) => ({
    userId,
    input
  }),
  isSilent: true
}));